<!-------- 黑名单附件 ---------->
<template>
  <upload-authorization-file
    ref="UploadAuthorizationFile"
    v-model="attachmentGroupIdTemp"
    upload-mode="fileId"
    :preview-api="previewBlacklistFileApi"
    :download-api="downloadBlacklistFileApi"
    :translate-data="{
      downloadTranslate: 'url'
    }"
    :props-data="{
      limit: 1,
      ...propsValue
    }"
    :request-params="requestParamsValue"
  />
</template>

<script>
// 组件
import UploadAuthorizationFile from '@/components/common/Upload/UploadAuthorizationFile'

// 后端api
import {
  previewBlacklistFileApi,
  downloadBlacklistFileApi
} from '@/api/supplier-management/blacklist'

export default {
  components: {
    UploadAuthorizationFile
  },

  model: {
    prop: 'attachmentGroupId',
    event: 'change'
  },

  props: {
    attachmentGroupId: {
      type: [String, Number],
      default: 0
    },

    // 其他上传配置
    propsData: {
      type: Object,
      default: () => {}
    },

    // 需要上传给后端的数据
    requestParams: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      attachmentGroupIdTemp: '',

      // api
      previewBlacklistFileApi,
      downloadBlacklistFileApi
    }
  },

  computed: {
    propsValue() {
      return {
        ...this.propsData
      }
    },

    requestParamsValue() {
      return {
        ...this.requestParams
      }
    }
  },

  watch: {
    attachmentGroupId: {
      handler: function(val) {
        this.attachmentGroupIdTemp = val
      },
      immediate: true
    },

    attachmentGroupIdTemp(val) {
      this.$emit('change', val)
    }
  },

  methods: {
    /**
     * 判断是否上传完成
     */
    uploadComplete() {
      return this.$refs.UploadAuthorizationFile.uploadComplete()
    }
  }
}
</script>
